import * as React from 'react';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultProjectUserGroupResource,
    ProjectUserGroupMutationResourceSchema,
    ProjectUserGroupPropertyValidation,
    useProjectUserGroupActions,
} from '../../../../resource/resources/persistables/user/projectUserGroupResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { handleMutationResult } from '../../../util/utilFunctions';

export const CreateProjectUserGroupDialog= ({ onClose, parentId }: {
    onClose: () => void;
    parentId: string;
}) => {
    const projectUserGroupActions = useProjectUserGroupActions()
    const addGroup = projectUserGroupActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProjectUserGroupMutationResourceSchema,
        defaultValues: {
            ...defaultProjectUserGroupResource,
        },
        submitHandler: async (data) => {
            await addGroup.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: handleMutationResult(() => {
                        onClose();
                    }),
                },
            );
        },
    });

    return (
        <EditChildBaseDialog
            edited={form.formState.isDirty}
            onClose={onClose}
            title={'Create Project User Group'}
            resourceType={ResourceType.PROJECT_USER_GROUP}
        >
            <Form_DisplayComponentBaseView form={form} onSubmit={onSubmit} canSubmitDefaultValue={false}>
                <div style={{ paddingTop: 5 }}>
                    <PropertyInputs.Name
                        control={form.control}
                        name={formNames.name}
                        readOnly={false}
                        propertyValidationInformation={{
                            resourceType: ResourceType.PROJECT_USER_GROUP,
                            propertyIdentifier: ProjectUserGroupPropertyValidation.NAME,
                            resourceId: undefined,
                        }}
                    />
                </div>
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};


